<mat-toolbar>
  <a href="#" [class.disabled]="isOnline ? null: true">
    <img id="logo" src="/assets/img/logo-ANETT.png" />
  </a>
  <mat-toolbar-row class="toolbar-mobile">
    <app-context class="flex"></app-context>
    <app-account-selector *ngIf="isOnline" class="flex justify-center"></app-account-selector>
    <div *ngIf="!isOnline">Mode Hors Ligne<mat-icon>signal_wifi_off</mat-icon></div>
    <div [ngClass]="'env ' + appEnv" *ngIf="appEnv">{{appEnv}}</div>
    <app-tools></app-tools>
  </mat-toolbar-row>
</mat-toolbar>
<mat-progress-bar value="100" [mode]="mode | async"></mat-progress-bar>